import './AddressInfo.scss';

const AddressInfo = ({
  firstName,
  lastName,
  address1,
  address2,
  city,
  provinceCode,
  zip,
}) => (
  <div className="AddressInfo">
    {(firstName || lastName) && (
      <div className="AddressInfo__name">
        {`${firstName || ''} ${lastName || ''}`}
      </div>
    )}
    <div className="AddressInfo__address">
      {[address1, address2].filter(Boolean).join(', ')}
    </div>
    <div className="AddressInfo__address">
      {`${city}, ${provinceCode} ${zip}`}
    </div>
  </div>
);

export default AddressInfo;
